import axios from "axios";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import "./Common.css";
import { Googlemap1, Googlemap2 } from "./Googlemap.js";

const ContactUs = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [company, setCompany] = useState("");
  const [Subject, setSubject] = useState("");
  const [Message, setMessage] = useState("");

  const contactusApi = () => {
    axios
      .post(`${window.sbapi}/api/Contactus`, {
        Firstname: firstname,
        Lastname: lastname,
        Email: email,
        Mobile: mobile,
        Company: company,
        Subject: Subject,
        Message: Message,
      })
      .then((response) => {
        if (response?.data?.message === "Success") {
          toast.success(" Your Order Is Successfuly Completed", {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setFirstname("");
          setLastname("");
          setEmail("");
          setMobile("");
          setCompany("");
          setSubject("");
          setMessage("");
        } else {
          // // console.log('Fail')
        }
      })
      .catch((er) => {
        // // console.log('er', er)
      });
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Header />
      <div style={{ background: "#f7f7f7;", padding: "30px" }}>
        <div className="alldata">
          <div className="forms">
            <div className="forms-a">
              <h1>We Love To Hear From You</h1>
            </div>
            <form className="forms-b">
              <input
                type="text"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                placeholder="First Name"
              />
              <input
                type="text"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                placeholder="Last Name"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email"
              />
              <input
                maxLength={11}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                type="tel"
                placeholder="Mobile No"
              />
              <input
                type="text"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder="Company"
              />
              <input
                type="text"
                value={Subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Subject"
              />
              <textarea
                value={Message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
              />
            </form>
            <div className="btn">
              <button onClick={contactusApi}> Submit </button>
            </div>
          </div>

          <div className="info">
            <h1>Our Outlets Addresses</h1>
            <h2>CHICHAWATNI BRANCH:</h2>
            <p>Dr. Farooq Shadeed Chowk, Block 11 Chichawatni, Pakistan</p>

            <h3>Contact Us:</h3>
            <p>Cell: +92 333 0333 183</p>
            <p>Phone: 040-548 1200</p>

            <h2>MIAN CHANNU BRANCH:</h2>
            <p>Mian Channu</p>

            <h3>Contact Us:</h3>
            <p>Cell: +92 307-1115300</p>
            <p>Phone: 065 266 5300</p>
          </div>
        </div>
        <div className="google-map">
          <div className="google-map1">
            <Googlemap1 />
          </div>
          <div className="google-map2">
            <Googlemap2 />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactUs;
